import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 144.3rem;
  margin: 0 auto;
`;